import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';

import './HeatmapCellDetailsAxisDescription.scss';

function HeatmapCellDetailsAxisDescription({ title, subUnits, label }) {
  const subUnitsList = subUnits ? Object.values(subUnits) : [];

  return (
    <div className="heatmap-cell-details-axis-description">
      <div className="heatmap-cell-details-axis-description__label">{title}</div>

      {/* Complex protein case */}
      {subUnitsList.length > 1 && (
        <div>
          <div className="heatmap-cell-details-axis-description__value">
            <span>Protein complex - {subUnitsList.length}</span>
            <svg className="heatmap-cell-details-axis-description__icon els-btn-icon">
              <use xlinkHref="#icon-chevron-right" />
            </svg>
          </div>
          <div className="heatmap-cell-details-axis-description__value__protein-list">
            {subUnitsList.map((subUnit) => (
              <div key={subUnit} className="heatmap-cell-details-axis-description__value__protein-list-item">
                {subUnit}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Single protein case */}
      {subUnitsList.length === 1 && (
        <div className="heatmap-cell-details-axis-description__value">
          {subUnitsList.map((subUnit) => (
            <span key={subUnit}>{subUnit}</span>
          ))}
          <svg className="heatmap-cell-details-axis-description__icon els-btn-icon">
            <use xlinkHref="#icon-chevron-right" />
          </svg>
        </div>
      )}

      {/* Default Case */}
      {subUnitsList.length === 0 && (
        <div className="heatmap-cell-details-axis-description__value">
          <InnerHTML tag="span" html={label} />
          <svg className="heatmap-cell-details-axis-description__icon els-btn-icon">
            <use xlinkHref="#icon-chevron-right" />
          </svg>
        </div>
      )}
    </div>
  );
}

HeatmapCellDetailsAxisDescription.propTypes = {
  title: PropTypes.string,
  subUnits: PropTypes.object,
  label: PropTypes.string,
};

export default HeatmapCellDetailsAxisDescription;
